<template>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <template #actions>
            <v-icon icon="mdi-close" @click="snackbar.show = false"/>
        </template>
    </v-snackbar>
</template>

<script setup>
import {useSnackbarStore} from "@/stores/snackBarStore";

const {snackbar} = useSnackbarStore();
</script>

<style scoped>

</style>
